export { default as WelcomeToHashrateSection } from './WelcomeToHashrateSection'
export { default as GetYourNFTSection } from './GetYourNFTSection'
export { default as JoinCommunitySection } from './JoinCommunitySection'
export { default as CommunityFeaturesSection } from './CommunityFeaturesSection'
export { default as ProjectsSection } from './ProjectsSection'
export { default as RoadmapSection } from './RoadmapSection'
export { default as WhoWeAreSection } from './WhoWeAreSection'
export { default as Home } from './Home'